import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getAllCountries,
  getCountryDetails
} from "../../services/DashboardService";
import { HttpCodes } from "../../constants/app.constant";

export interface Icountry {
  key: string;
  label: string;
  countryId?: string;
  productBrandId?: string;
  uniqueId?: string;
}

export const getCountryOptionKey = (option?: Icountry | null | "") => {
  if (!option || typeof option === "string") {
    return "";
  }
  return (
    option.uniqueId ||
    `${option.key}-${option.countryId ?? ""}-${option.productBrandId ?? ""}`
  );
};

const mapCountryOption = (country: any): Icountry => ({
  label: country.countryName,
  key: country.countryCode,
  countryId: country.countryId,
  productBrandId: country.productBrandId,
  uniqueId: `${country.countryCode}-${country.countryId}-${country.productBrandId}`
});

export interface State {
  countryList: any[];
  countryListAPIData: any | null;
  isCountryListLoading: boolean;
  countryDetails: any[];
  isCountryDetailsLoading: boolean;
  countryError: string;
  isCommunityUser: boolean;
  selectedCountry?: Icountry;
  isSJPR?: boolean;
}

const initialState: State = {
  countryList: [],
  isCountryListLoading: false,
  countryDetails: [],
  isCountryDetailsLoading: false,
  countryListAPIData: [],
  countryError: "",
  isCommunityUser: false,
  selectedCountry: {
    key: "",
    label: ""
  },
  isSJPR: true
};

export const CountryListThunk = createAsyncThunk(
  "country",
  async (payload: any, thunkApi) => {
    try {
      console.log("IN CLUNTRY DETAIL SLICE");
      const response: any = await getAllCountries(payload ?? "");
      let data = response?.data;
      if (data?.responseCode === HttpCodes.SUCCESS) {
        return data.data || [];
      } else if (response?.status === HttpCodes.SUCCESS_204) {
        return { isCommunityUser: payload && true, error: 204 };
      }
      return [];
    } catch (e) {
      console.log(e);
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const CountryDetailsThunk = createAsyncThunk(
  "country/details",
  async (payload: any, thunkApi) => {
    try {
      const response = await getCountryDetails(payload);
      if (response.responseCode == HttpCodes.SUCCESS) {
        return response.data || [];
      }
      return [];
    } catch (e) {
      console.log(e);
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const countryListSlice = createSlice({
  name: "country",
  initialState,
  reducers: {
    resetState: () => initialState,
    setList: (state, action) => {
      state.countryList = action.payload;
    },
    setSelectedCountry: (state, action) => {
      state.selectedCountry = action.payload;
    },
    resetSelectedCountry: (state) => {
      state.selectedCountry = {
        key: "",
        label: ""
      };
    }
  },
  extraReducers: (builder) => {
    builder.addCase(CountryListThunk.pending, (state, action) => {
      state.isCountryListLoading = true;
    });
    builder.addCase(CountryListThunk.fulfilled, (state, action) => {
      state.isCountryListLoading = false;
      const isCommunityUserExists =
        sessionStorage.getItem("isShadowUserAccess");
      !isCommunityUserExists &&
        sessionStorage.setItem(
          "isShadowUserAccess",
          action.payload?.isCommunityUser
        );
      state.isCommunityUser = action.payload?.isCommunityUser;
      if (action.payload?.error) {
        state.countryError = action.payload?.error;
      } else {
        state.countryListAPIData = action.payload || [];
        state.isSJPR = action.payload?.isSJPR || false;
        state.countryList = (action.payload.countryList || []).map(
          mapCountryOption
        );
      }
    });
    builder.addCase(CountryListThunk.rejected, (state, action) => {
      state.isCountryListLoading = false;
      state.countryList = [];
    });
    builder.addCase(CountryDetailsThunk.pending, (state, action) => {
      state.isCountryDetailsLoading = true;
    });
    builder.addCase(CountryDetailsThunk.fulfilled, (state, action) => {
      state.isCountryDetailsLoading = false;
      state.countryDetails = action.payload;
    });
    builder.addCase(CountryDetailsThunk.rejected, (state, action) => {
      state.isCountryDetailsLoading = false;
      state.countryDetails = [];
    });
  }
});

export const { setList, resetState, setSelectedCountry, resetSelectedCountry } =
  countryListSlice.actions;

export default countryListSlice.reducer;
